import SelectOptionModel from '@/Modules/Dataset/SelectOptionModel.js'
import DocumentTypeModel from '@/Modules/Document/DocumentType/DocumentTypeModel.js'
import axios from 'axios'

export default class DocumentTypeService {
  static list = ({ parameters, filters }) =>
    axios.get(`/document-types${filters}`, {
      params: parameters,
      excludeLoader: true,
    })
  static create = payload => axios.post(`/document-types`, payload)
  static update = (id, payload) => axios.put(`/document-types/${id}`, payload)
  static show = id =>
    axios
      .get(`document-types/${id}`)
      .then(response => new DocumentTypeModel(response.data?.data))
  static delete = id => axios.delete(`/document-types/${id}`)
  static all = () =>
    axios
      .get(`/document-types/all`)
      .then(response =>
        _.map(response.data.data, item => new SelectOptionModel(item))
      )
}
